import { IModelEntity } from '@pit/core';

export enum ExternalOrderTransferState {

    NotTransferred = 1,
    TransferError = 2,
    Transferred = 4,
    Internal = 8,
    ReserveForArchive = 16,
    Archived = 32

}


export interface IDtoResourceCheckItem extends IModelEntity {

    checkResult?: number;
    faultArea?: string;
    faultCategory?: string;
    faultCode?: string;
    faultDescription?: string;
    faultPenalty?: number;
    isFault?: boolean;
    notes?: string;

    externalOrderId?: string;
    externalOrderTransferStateExport?: ExternalOrderTransferState;
    externalOrderTransferTimestampExport?: Date;
    externalOrderTransferStateImport?: ExternalOrderTransferState;
    externalOrderTransferTimestampImport?: Date;

    getFullDescription?: () => string;

}
